/**
 * Это похоже на какое-то двинутое временное решение? Ну, собственно да, оно таким и является:)
 */
export const BAYER_ID = "d544e46b75774d48b3654bdc2f209998";
export const DDD_ID = "104b268d94d74dd7b71c818e34b6ae1a";

export enum STATUSES {
    'Draft' = 0,
    'Open' = 1,
    'Announcement' = 2,
    'Voting' = 3,
    'Summarizing' = 4,
    'Completed' = 5,
    'Archived' = 6,
    'Deleted' = 7,
}

export enum STATUSES_NEW {
  'Open' = 1,
  'Completed' = 5,
}

export const STATUSES_List: {
    label: string;
    value: number;
  }[] = Object.entries(STATUSES)
    .map(([label, value]) => ({ label: label, value: value as number }))
    .filter(x => !isNaN(x.value));
/**
 * Это похоже на какое-то двинутое временное решение? Ну, собственно да, оно таким и является:)
 */
export const BAYER_ID = "d544e46b75774d48b3654bdc2f209998";
export const DDD_ID = "104b268d94d74dd7b71c818e34b6ae1a";

export enum STATUSES {
    'Draft' = 0,
    'Open' = 1,
    'Announcement' = 2,
    'Voting' = 3,
    'Summarizing' = 4,
    'Completed' = 5,
    'Archived' = 6,
    'Deleted' = 7,
}

export enum STATUSES_NEW {
  'Open' = 1,
  'Completed' = 5,
}

export const STATUSES_List: {
    label: string;
    value: number;
  }[] = Object.entries(STATUSES)
    .map(([label, value]) => ({ label: label, value: value as number }))
    .filter(x => !isNaN(x.value));
